import * as React from 'react'
import { Box } from '@mui/material'
import DataGridPremiumDemo from '@/components/Table/DataGrid'
import AlertsFiltersBar, {
  AlertsFilters,
} from '@components/ConsumerNotifications/AlertsFiltersBar'
import AlertsManagePopover, {
  AlertsManageValues,
} from '@components/ConsumerNotifications/AlertsManagePopover'
import NewNotificationDialog from '@/components/Notifications/NewNotificationDialog'

import historyColumns from '@/components/features/config/columns/consumers/history.columns'

import {
//  getMockHistoryFor,
  getGenericMockHistory,
} from '@/mockdata/replacementHistory.mock'
import { debugLog } from '@/utils/debugLog'

const SensorsHistory: React.FC = () => {
  const columns = historyColumns
  const [rows, setRows] = React.useState<any[]>([])

  const [openComposer, setOpenComposer] = React.useState(false)
  const [filters, setFilters] = React.useState<AlertsFilters>()
  const [manageAnchor, setManageAnchor] = React.useState<HTMLElement | null>(
    null
  )
  const [manageValues, setManageValues] = React.useState<AlertsManageValues>({
    mode: 'enabled',
    until: '',
    alertType: 'all',
    messagesMode: 'enabled',
    messagesUntil: '',
    messagesAlertType: 'all',
    alertsMode: 'enabled',
    alertsUntil: '',
    alertsAlertType: 'all',
  })

  const [selectedRowId, setSelectedRowId] = React.useState<
    string | number | null
  >(null)


  const handleRowDoubleClick = React.useCallback((params: any) => {
    setSelectedRowId(params?.row?.id ?? params?.id)
  }, [])

  React.useEffect(() => {
    if (!Array.isArray(rows) || rows.length === 0) {
      const fallback =
        /*selectedRowId
        ? getMockHistoryFor(String(selectedRowId), 3)
        : */ getGenericMockHistory()
      setRows(fallback)
    }
  }, [selectedRowId])

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <AlertsFiltersBar
        value={filters}
        onChange={setFilters}
        onSearch={f => debugLog('search:', f)}
        alertsMode={
          manageValues.alertsMode === 'muted' || manageValues.messagesMode === 'muted'
            ? 'muted'
            : 'enabled'
        }
        onOpenNotifications={el => setManageAnchor(el)}
        showNotificationVisible={false}
        showCheckBox={false}
      />

      <Box
        sx={{
          width: '95%',
          maxWidth: '100%',
          height: '70vh',
          display: 'flex',
          gap: 2,
          overflow: 'hidden',
          pb: 10,
          pt: 3,
          justifyContent: 'end',
        }}
      >
        <Box sx={{ flex: '1 1 60%', minWidth: 60, display: 'flex', gap: 2 }}>
          <Box height={240}>
            <DataGridPremiumDemo
              columns={columns}
              rows={rows}
              width="100%"
              hideFooter
              headerPosition="bottom"
              pageSize={10}
              onRowDoubleClick={handleRowDoubleClick}
            />
          </Box>
        </Box>
      </Box>

      <AlertsManagePopover
        anchorEl={manageAnchor}
        open={Boolean(manageAnchor)}
        onClose={() => setManageAnchor(null)}
        values={manageValues}
        onChange={v => setManageValues(v)}
        onSave={v => {
          setManageValues(v)
          setManageAnchor(null)
        }}
      />

      <NewNotificationDialog
        open={openComposer}
        onClose={() => setOpenComposer(false)}
        onSend={() => setOpenComposer(false)}
      />
    </Box>
  )
}

export default SensorsHistory
